import {Component, OnInit, Input, NgModule, NO_ERRORS_SCHEMA, AfterViewInit} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {Branch} from '../branch';
import {BranchService} from '../branch.service';
import {ActivatedRoute, Router} from '@angular/router';
import {SharedService} from '../../../../services/SharedService.service';
import {ConfirmationService, Message} from 'primeng/api';
import {MessageService} from 'primeng/components/common/messageservice';
import {NgbActiveModal, NgbModal, NgbModalOptions, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {AppLogComponent} from '../../../../components/app-log/app-log.component'
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import {BrowserModule} from "@angular/platform-browser";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {CommonModule} from "@angular/common";
import {ConfirmDialogModule, DropdownModule, MessagesModule} from "primeng/primeng";
import {Http} from "@angular/http";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {RecordDataComponent} from "../../../../components/record-data";
import {Tax} from "../../taxes/tax";
import {AppArcComponent} from '../../../../components/app-arc';
import {OrganizationService} from '../../../setting/organization/organization.service';
import {OrganizationShowComponent} from "../../organization/organization-show/organization-show.component";
import {AccountsService} from '../../../fin/accounts/accounts.service';
import {CostcentersService} from '../../../fin/costcenters/costcenters.service';
import {MyInputsModule} from "../../../../my-inputs/my-inputs.module";
import {CityService} from '../../cities/cities.service';
import {StoreService} from '../../stores/store.service';
import {UserService} from '../../../../services';


@NgModule({
    imports: [CommonModule, FormsModule, DropdownModule, MessagesModule,MyInputsModule,
        ReactiveFormsModule,
        ConfirmDialogModule,
        TranslateModule.forChild()
    ],
    declarations: [
        BranchesShowComponent
    ],
    entryComponents: [
        BranchesShowComponent
    ],
    exports: [],
    providers: [SharedService, BranchService, MessageService, ConfirmationService],
    schemas: [NO_ERRORS_SCHEMA]
})
@Component({
    selector: 'app-branches-show',
    templateUrl: './branches-show.component.html',
    styleUrls: ['./branches-show.component.scss'],
    providers: [BranchService, ConfirmationService, MessageService]
})


export class BranchesShowComponent implements OnInit, AfterViewInit {

  id: string;
  branch = new Branch();
  filter: any;
  @Input() delId;
  @Input() scrId;
  @Input() oldData;
  @Input() newData;
  @Input() newDatap;
  @Input() modelName;
  modalRef: NgbModalRef;

  alltreeacc: any[] = [];
  alltreecost: any[] = [];
  allusers: any[] = [];
  allcities: any[] = [];
  allstores: any[] = [];
  allcurrencies: any[] = [];
  branchForm: FormGroup;
  private sub: any;
  msgs: Message[] = [];
  statusVal = [{'val': 1, 'title': 'Active'}, {'val': 2, 'title': 'Inactive'}];

  private _editButton: any;
  private _deleteButton: any;
  private _searchButton: any;
  private _newButton: any;
  private _printButton: any;
  hiddenFields: any[] = [];

    constructor(private route: ActivatedRoute,
                private router: Router,
                private sharedservice: SharedService,
                private branchService: BranchService,
                private cityService: CityService,
                private storeService: StoreService,
                private userService: UserService,
                private accountsService: AccountsService,
                private coctcenterService: CostcentersService,
                private modalService: NgbModal,
                public activeModal: NgbActiveModal,
                public translate: TranslateService,
                private confirmationService: ConfirmationService,
                private organizationService: OrganizationService,
                private messageService: MessageService) {
                this.msgs = [];
        const userdata = JSON.parse(localStorage.getItem('currentUser'));

        if (userdata && userdata.lang) {
            this.translate.use(userdata.lang);
        }
        this.sharedservice.setTitle(this.route.snapshot.data.title);
      this.sharedservice.setItemShow(BranchesShowComponent);
        this.sharedservice.setButtons([
            {label: 'Delete', icon: 'fa-trash', btnClass: 'btn-danger', btnId: 'deleteButton'},
            {label: 'Edit', icon: 'fa-edit', btnClass: 'btn-warning', btnId: 'editButton'},
            // {label: 'Print', icon: 'fa-print', btnClass: 'btn-skype', btnId: 'printButton'},
            {label: 'Add', icon: 'fa-plus', btnClass: 'btn-info', btnId: 'newButton'},
            {label: 'Query', icon: 'fa-search', btnClass: 'btn-primary', btnId: 'searchButton'},
        ]);
        this.sharedservice.setModelName('branches');
    }

    recordData() {
        const options: NgbModalOptions = {

            beforeDismiss: () => {
                // this.changePicUrl();

                return true;
            }
        };
        JSON.parse(localStorage.getItem('filter'));

        const modalRef = this.modalService.open(RecordDataComponent, options);
        modalRef.componentInstance.refRec = this.branch;
        modalRef.componentInstance.rowId = '';

    }

    ngAfterViewInit() {
      if(!this.scrId && !this.oldData && !this.scrId) {

            this._editButton = document.getElementById('editButton');
            this._deleteButton = document.getElementById('deleteButton');
            this._searchButton = document.getElementById('searchButton');
            this._newButton = document.getElementById('newButton');
            this._printButton = document.getElementById('printButton');

            if (this._editButton) {
                this._editButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/branches/edit', this.id]);
                });
            }
            if (this._deleteButton) {
                this._deleteButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.deleteBranch(this.branch);
                });
            }
            if (this._newButton) {
                this._newButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/branches']);
                });
            }
            if (this._searchButton) {
                this._searchButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/branches/search']);
                });
            }
        }
    }

    ngOnInit() {
      this.accountsService.getAllGroups(0).subscribe(
        group => {
          this.alltreeacc = group;
        });
      this.coctcenterService.getAllGroups(0).subscribe(
        group => {
          this.alltreecost = group;
        });

      this.userService.getAllUsers().subscribe(
        group => {
          this.allusers = group.userslist;
        });

      this.cityService.getAllCities().subscribe(
        group => {
          this.allcities = group;
        });

      this.storeService.getAllStores().subscribe(
        group => {
          this.allstores = group.storeslist;
        });

      this.organizationService.getAllCurrencies().subscribe(
          data => {
            this.allcurrencies = data;
          });


        this.msgs=[];
        this.sub = this.route.params.subscribe(params => {
            this.id = params['id'];
        });

        this.branchForm = new FormGroup({
          id: new FormControl({value: '', disabled: true}, Validators.required),
          name: new FormControl({value: '', disabled: true}, Validators.required),
          address: new FormControl({value: '', disabled: true}, Validators.required),
          telephone: new FormControl({value: '', disabled: true}, Validators.required),
          fax: new FormControl({value: '', disabled: true}, Validators.required),
          status: new FormControl({value: '', disabled: true}, Validators.required),
          manager_id: new FormControl({value: '', disabled: true}, Validators.required),
          store_id: new FormControl({value: '', disabled: true}, Validators.required),
          city_id: new FormControl({value: '', disabled: true}, Validators.required),
          currency_id: new FormControl({value: '', disabled: true}, Validators.required),
        });

        this.fieldsControl('setting.branches');

        if (this.id) {
          this.msgs=[];
          this.activeModal.dismiss('');
          this.oldData = false;
          this.newData = false;
          this.newDatap = true;

          this.delId = false;
          localStorage.removeItem('filter');
          const msg = JSON.parse(localStorage.getItem('showMessages'));
          if (msg) {
              localStorage.removeItem('showMessages');
              this.msgs = msg;
              this.msgs=[];
          }
          this.branchService.getById(this.id).subscribe(
              branch => {
                this.id = branch.id;
                this.branch = branch;
                this.branchForm.patchValue({
                  id: branch.id,
                  fax: branch.fax,
                  name: branch.name,
                  status: branch.status,
                  city_id: branch.city_id,
                  address: branch.address,
                  store_id: branch.store_id,
                  telephone: branch.telephone,
                  manager_id: branch.manager_id,
                  currency_id: branch.currency_id,
                });

              }, error => {
                  console.log(error);
              }
          );
        }
        if (this.scrId) {
            this.oldData = false;
            this.newData = false;

            this.delId = false;

            this.branchService.getById(this.scrId).subscribe(
                branch => {
                  this.id = branch.id;
                  this.branch = branch;
                  this.branchForm.patchValue({
                      id: branch.id,
                      fax: branch.fax,
                      name: branch.name,
                      status: branch.status,
                      city_id: branch.city_id,
                      address: branch.address,
                      store_id: branch.store_id,
                      telephone: branch.telephone,
                      manager_id: branch.manager_id,
                      currency_id: branch.currency_id,
                  });
                }, error => {
                    console.log(error);
                }
            );

        }
        if (this.delId) {
          this.oldData = false;
          this.newData = false;
          this.newDatap = !this.newDatap ;
          this.branchService.getTrashedById(this.delId).subscribe(
            branch => {
                this.id = branch.id;
                this.branch = branch;
                this.branchForm.patchValue({
                  id: branch.id,
                  fax: branch.fax,
                  name: branch.name,
                  status: branch.status,
                  city_id: branch.city_id,
                  address: branch.address,
                  store_id: branch.store_id,
                  telephone: branch.telephone,
                  manager_id: branch.manager_id,
                  currency_id: branch.currency_id,
                });
            }, error => {
                console.log(error);
            }
          );
        }

        if (this.oldData && this.newData) {
          this.branch = this.newData;
          this.branchForm.patchValue({
            id: this.newData.id,
            fax: this.newData.fax,
            name: this.newData.name,
            status: this.newData.status,
            city_id: this.newData.city_id,
            address: this.newData.address,
            store_id: this.newData.store_id,
            telephone: this.newData.telephone,
            manager_id: this.newData.manager_id,
            currency_id: this.newData.currency_id,
          });
        }
    }

    fieldsControl(screen: string = '') {
        if (screen === '') {
            return;
        }
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        if (!userdata.fields) {
            this.hiddenFields = [];
        } else {
            this.hiddenFields = (userdata.fields.screens[screen]) ? userdata.fields.screens[screen] : [];
        }
    }

    permissionAllow(button: string): boolean {
        let userRoles: any[] = [];
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        if (userdata) {
            userRoles = userdata.roles.description;
        }
        let role: string = '';
        switch (button) {
            case 'newButton': {
                role = 'create';
                break;
            }
            /*  case 'recordDataButton': {
                  role = 'recordData';
                  break;
              }*/
            case 'saveButton': {
                role = 'update';
                break;
            }
            case 'deleteButton': {
                role = 'delete';
                break;
            }
            case 'searchButton': {
                role = 'search';
                break;
            }
            case 'excelButton': {
                role = 'excel';
                break;
            }
            case 'printButton': {
                role = 'print';
                break;
            }
            case 'historyButton': {
                role = 'history';
                break;
            }
            case 'restoreButton': {
                role = 'restore';
                break;
            }
            case 'attachmentsButton': {
                role = 'attachments';
                break;
            }
            case 'rowinfo': {
                role = 'rowinfo';
                break;
            }

            default: {
                role = '';
                break;
            }
        }
        if (userRoles.indexOf('setting.branches.' + role) >= 0) {
            return true;
        }
        return false;
    }

    deleteBranch(branch: Branch) {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Delete'),
            message: this.translate.instant('Are you sure of delete ?'),
            icon: 'fa fa-trash',
            accept: () => {
              if (branch) {
                this.branchService.delete(branch.id).subscribe(
                  res => {
                    this.msgs = [];
                    if (res.result == false) {
                      this.msgs.push({
                        severity: 'error',
                        summary: '',
                        detail: this.translate.instant(res.message)
                      });
                    } else {
                      this.msgs.push({
                        severity: 'success',
                        summary: '',
                        detail: this.translate.instant('Delete completed')
                      });
                      setTimeout(() => {
                          this.router.navigate(['/branches']);
                      }, 1000);
                    }
                    localStorage.setItem('showMessages', JSON.stringify(this.msgs));
                  }
                );
              }
            }
        });
    }

    recoverEdit(branch: Branch) {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Undo Edit'),
            message: this.translate.instant('Are you sure of undo ?. All data will be recover as seen in screen and any other editing will be dismiss'),
            icon: 'fa fa-undo',
            accept: () => {
                if (branch) {
                    this.branchService.update(branch).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Data returned')
                            });
                            this.activeModal.close('done');
                            this.router.navigate(['/branches/show', branch.id]);
                        }
                    );
                }
            }
        });
    }

    undotrashed() {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Undo Delete'),
            message: this.translate.instant('Are you sure about recover deleted item?'),
            icon: 'fa fa-undo',
            accept: () => {
                if (this.delId) {
                    this.branchService.restoreTrashedById(this.delId).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Deleted item recovered')
                            });
                            this.activeModal.dismiss('close click');
                            this.router.navigate(['/branches/list']);
                        }
                    );
                }
            }
        });
    }

    showattachement(row_id: string) {
        console.log(row_id)
        if (row_id) {
            const options: NgbModalOptions = {

                beforeDismiss: () => {
                    // this.changePicUrl();
                    return true;
                }
            };
            const modalRef = this.modalService.open(AppArcComponent, options);
            modalRef.componentInstance.rowId = row_id;
            modalRef.componentInstance.screenName = this.modelName;
        }
    }

    showHistory(row_id: string) {
        if (row_id) {
            const modalRef = this.modalService.open(AppLogComponent);
            modalRef.componentInstance.rowId = row_id;
            modalRef.componentInstance.refShow = BranchesShowComponent;

        }
    }


}



// WEBPACK FOOTER //
// ./src/app/views/setting/branches/branches-show/branches-show.component.ts